module.exports = __webpack_public_path__ + "static/img/weather66.103551fa.png";